import { combineReducers } from 'redux';

const paymentConditionsInitial =
  [
    {type: 'date', val: '', percent: 100, },
    {type: 'date', val: '', percent: 0, },
    {type: 'date', val: '', percent: 0, },
    {type: 'date', val: '', percent: 0, },
    {type: 'date', val: '', percent: 0, },
    {type: 'date', val: '', percent: 0, },
    {type: 'date', val: '', percent: 0, },
    {type: 'date', val: '', percent: 0, },
    {type: 'date', val: '', percent: 0, },
    {type: 'date', val: '', percent: 0, },
  ]
;

const paymentConditions = (state, action) => {
  switch (action.type) {
    case 'SET_PAYMENT_CONDITIONS':
      return action.p;
    case 'RESET_ORDER_CONDITIONS':
      return [
        {type: 'date', val: '', percent: 100, },
        {type: 'date', val: '', percent: 0, },
        {type: 'date', val: '', percent: 0, },
        {type: 'date', val: '', percent: 0, },
        {type: 'date', val: '', percent: 0, },
        {type: 'date', val: '', percent: 0, },
        {type: 'date', val: '', percent: 0, },
        {type: 'date', val: '', percent: 0, },
        {type: 'date', val: '', percent: 0, },
        {type: 'date', val: '', percent: 0, },
      ];
    default:
      return state || paymentConditionsInitial;
  }
};

const selectedOptions = (state = '', action) => {
  switch (action.type) {
    case 'SET_SELECTED_OPTIONS':
      return { ...state, ...action.p };
    case 'RESET_ORDER_CONDITIONS':
      return '';
    default:
      return state;
  }
};

const requestedDelivDate = (state = '', action) => {
  switch (action.type) {
    case 'SET_REQUESTED_DELIV_DATE':
      return action.p || '';
    case 'RESET_ORDER_CONDITIONS':
      return '';
    default:
      return state;
  }
};

const comment = (state = '', action) => {
  switch (action.type) {
    case 'SET_ORDER_COMMENT':
      return action.p;
    case 'RESET_ORDER_CONDITIONS':
      return '';
    default:
      return state;
  }
};

const qty = (state = 1, action) => {
  switch (action.type) {
    case 'SET_ORDER_QTY':
      return action.p;
    case 'RESET_ORDER_CONDITIONS':
      return 1;
    default:
      return state;
  }
};

const paymentOn = (state = false, action) => {
  switch (action.type) {
    case 'SET_ORDER_PAYMENT_PANE_VISIBILITY':
      return action.p;
    case 'RESET_ORDER_CONDITIONS':
      return false;
    default:
      return state;
  }
};

const setId = (state = '', action) => {
  switch (action.type) {
    case 'SET_ORDER_SET_ID':
      return action.p;
    default:
      return state;
  }
};

const validationMode = (state = false, action) => {
  switch (action.type) {
    case 'SET_ORDER_VALIDATION_MODE':
      return true;
    case 'RESET_ORDER_CONDITIONS':
      return false;
    default:
      return state;
  }
};

export default combineReducers ({
  setId,
  paymentConditions,
  selectedOptions,
  requestedDelivDate,
  comment,
  qty,
  paymentOn,
  validationMode
});



// WEBPACK FOOTER //
// ./src/store/reducers/order-conditions.js